export default __webpack_public_path__ + "static/media/Clear_icon.140976d3.svg";